
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608442571887",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3894",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M153.6 256H51.2C22.4 256 0 233.6 0 204.8s22.4-51.2 51.2-51.2h102.4c28.8 0 51.2 22.4 51.2 51.2S182.4 256 153.6 256z m819.2 0H358.4c-28.8 0-51.2-22.4-51.2-51.2s22.4-51.2 51.2-51.2h614.4c28.8 0 51.2 22.4 51.2 51.2s-22.4 51.2-51.2 51.2zM153.6 563.2H51.2C22.4 563.2 0 540.8 0 512s22.4-51.2 51.2-51.2h102.4c28.8 0 51.2 22.4 51.2 51.2s-22.4 51.2-51.2 51.2z m819.2 0H358.4c-28.8 0-51.2-22.4-51.2-51.2s22.4-51.2 51.2-51.2h614.4c28.8 0 51.2 22.4 51.2 51.2s-22.4 51.2-51.2 51.2zM153.6 870.4H51.2C22.4 870.4 0 848 0 819.2 0 790.4 22.4 768 51.2 768h102.4c28.8 0 51.2 22.4 51.2 51.2 0 28.8-22.4 51.2-51.2 51.2z m819.2 0H358.4c-28.8 0-51.2-22.4-51.2-51.2 0-28.8 22.4-51.2 51.2-51.2h614.4c28.8 0 51.2 22.4 51.2 51.2 0 28.8-22.4 51.2-51.2 51.2z",
        "p-id": "3895"
      }
    }
  ]
})
    }
  